/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Stress severity ratings
 */
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export type StressSeverityRatingEnum = 'Low' | 'Medium' | 'High' | 'Very High';

export const StressSeverityRatingEnum = {
    Low: 'Low' as StressSeverityRatingEnum,
    Medium: 'Medium' as StressSeverityRatingEnum,
    High: 'High' as StressSeverityRatingEnum,
    VeryHigh: 'Very High' as StressSeverityRatingEnum
};

marker('Low');
marker('Medium');
marker('High');
marker('Very High');

